import { useToasts } from "../../components/Toasts"

export default useToasts
